<template>
  <b-row align-v="start" class="px-1" no-gutters>
    <b-col v-if="productImageUrl" cols="auto">
      <b-link href="#links-goes-here">
        <b-img :src="productImageUrl" alt="" class="img-border product-image"/>
      </b-link>
    </b-col>
    <b-col class="ml-2">
      <h3 class="m-0 product-name mb-1">
        <template v-if="productName">
          {{ productName }}
        </template>
        <template v-else>Home<em>Safe</em><sup>&reg;</sup> Smart Tracker</template>
      </h3>
    </b-col>
    <b-col>
      <h3 class="m-0 text-right">
        <span>
          {{ productPrice }}
        </span>
      </h3>
      <b-button block class="m-0 p-0 text-right" variant="link" @click="$emit('remove-item', orderItemId)">remove
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'PetTrackingDeviceProduct',
  props: {
    orderItemId: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: false,
      default: null,
    },
    productImageUrl: {
      type: String,
      required: false,
      default: null
    },
    productPrice: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>